export default __webpack_public_path__ + "static/media/honeyCoin_farming.1897a6f1.jpg";